// TODO (Denis): This should be simply CompanyModule
export enum ApiKeyScope {
  Projects,
  Customers,
  Materials,
  MaterialPackages,
  EmployeeHours,
  Users,
}
